import React, { useState, useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, IconButton, Divider } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { dataService } from '../../Services/data/data.service';
import MenuIcon from '@mui/icons-material/Menu';
import { ScanBarcode, History, Home, Users, Server, Forklift } from 'lucide-react';

export const NavDrawer = (props) => {
    const classes = useStyles();
    let navigate = useNavigate();
    let location = useLocation();

    const [open, setOpen] = React.useState(false);
    const [page, setPage] = React.useState(location.pathname);
    const [helpFilesDialogOpen, setHelpFilesDialogOpen] = React.useState(false);
    const [prevLocation, setPrevLocation] = useState(null);

    const { t } = useTranslation();

    useEffect(() => {
        if (prevLocation && prevLocation !== location.pathname) {
            // Do something with the new location
            setPage(location.pathname);
        }
        setPrevLocation(location.pathname);
    }, [location, prevLocation]);


    const toggleDrawer = () => {
        setOpen(!open);
    }

    const handleRedirect = (link) => {

        if (link === "/help") {
            setHelpFilesDialogOpen(true);
        } else {
            navigate(link);
            setPage(link);
        }
    }


    return (
        <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}
            classes={{
                paper: clsx({
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                }),
            }}>
            <React.Fragment>
                <div className={classes.toolbar}>
                    <IconButton onClick={toggleDrawer} style={{ height: '51px', width: '51px' }}>
                        <MenuIcon style={{ fontSize: '30px' }} className={classes.menuIcon} ></MenuIcon>
                    </IconButton>
                </div>
                <Divider />
                <List className={classes.list}>
                    <ListItem className={clsx({ [classes.activeList]: page === "/" })} style={{ paddingLeft: "13px" }} button key="workstations" onClick={() => handleRedirect("/")}>
                        <ListItemIcon className={clsx(classes.listIcon, { [classes.activeText]: page === "/" })}>
                            <Home className={clsx({ [classes.activeIcon]: page === "/" })} size={24} absoluteStrokeWidth strokeWidth={1.4} />
                        </ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page === "/" })} primary={t('Checkpoints')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    <ListItem className={clsx({ [classes.activeList]: page.includes("/workstation") || page.includes("/order") })} style={{ paddingLeft: "13px" }} button key="overview" onClick={() => handleRedirect("/workstation")}>
                        <ListItemIcon className={clsx(classes.listIcon, { [classes.activeText]: page.includes("/workstation") || page.includes("/order") })} >
                            <ScanBarcode className={clsx({ [classes.activeIcon]: page.includes("/workstation") || page.includes("/order") })} size={24} absoluteStrokeWidth strokeWidth={1.4} />
                        </ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page.includes("/workstation") || page.includes("/order") })} primary={t('Production')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    <ListItem className={clsx({ [classes.activeList]: page.includes("/history") })} style={{ paddingLeft: "13px" }} button key="history" onClick={() => handleRedirect("/history")}>
                        <ListItemIcon className={clsx(classes.listIcon, { [classes.activeText]: page.includes("/history") })}>
                            <History className={clsx({ [classes.activeIcon]: page.includes("/history") })} size={24} absoluteStrokeWidth strokeWidth={1.4} />
                        </ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page.includes("/history") })} primary={t('History')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>

                    {/* Bottom */}
                    <ListItem style={{ paddingLeft: "13px", position: "absolute", bottom: "100px" }} className={clsx({ [classes.activeList]: page.includes("/transport") })} button key="transport" onClick={() => handleRedirect("/transport")}>
                        <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page.includes("/transport") })}><Forklift className={classes.navigationIcon} /></ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page.includes("/transport") })} primary={t('Transport')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    <ListItem style={{ paddingLeft: "13px", position: "absolute", bottom: "50px" }} className={clsx({ [classes.activeList]: page.includes("/services") })} button key="services" onClick={() => handleRedirect("/services")}>
                        <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page.includes("/services") })}><Server className={classes.navigationIcon} /></ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page.includes("/services") })} primary={t('Services')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    <ListItem style={{ paddingLeft: "13px", position: "absolute", bottom: "0px" }} className={clsx({ [classes.activeList]: page.includes("/users") })} button key="gebruikers" onClick={() => handleRedirect("/users")}>
                        <ListItemIcon className={clsx(classes.navigationIconContainer, { [classes.activeIconContainer]: page.includes("/users") })}><Users className={classes.navigationIcon} /></ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page.includes("/users") })} primary={t('Gebruikers')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    {/* {props.user.isAdministrator &&
                        <ListItem className={clsx({ [classes.activeList]: page.includes("/workinstructions") })} style={{ paddingLeft: "13px" }} disabled={!props.workstation.selectedWorkstation} button key="workinstructionoverview" onClick={() => handleRedirect("/workinstructions")}>
                            <ListItemIcon className={clsx({ [classes.activeText]: page.includes("/workinstructions") })}>
                                <img style={{ width: "21px" }} className={clsx({ [classes.activeImage]: page.includes("/workinstructions") })} alt="done" src={process.env.PUBLIC_URL + '/img/instructions.svg'}></img>
                            </ListItemIcon>
                            <ListItemText className={clsx({ [classes.activeText]: page.includes("/workinstructions") })} primary={t("Workinstructions")} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                        </ListItem>
                    } */}

                </List>

            </React.Fragment>
        </Drawer>
    )
}

const useStyles = makeStyles((theme) => ({
    spacer80: {
        height: '80px'
    },

    gridmargin: {
        paddingRight: "50px !important"
    },

    workstation: {
        height: "100px",
        margin: "20px",
        fontSize: "20pt",
        textAlign: "center",
        fontWeight: "bold",
        color: FlagstoneTheme.primaryColor,
        textDecoration: 'none'
    },

    navButton: {
        textDecoration: 'none'
    },

    background: {
        height: '100vh',
        width: '100%'
    },

    drawer: {
        width: '260px',
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: '260px',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        width: '50px',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden'
    },
    stockIcon: {
        width: "21px",
    },


    activeList: {
        backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main + " !important",
        }
    },

    listIcon: {
        color: "#0C0E29 !important"
    },

    activeText: {
        color: FlagstoneTheme.palette.secondary.main,
        '&:hover': {
            color: "white",
        }
    },
    activeWorkinstructions: {
        filter: 'brightness(0) invert(1)',
        color: FlagstoneTheme.palette.secondary.main,
        '&:hover': {
            color: "white",
        }
    },

    navigationIconContainer: {
        color: FlagstoneTheme.palette.text.primary + " !important",
    },

    activeIconContainer: {
        color: FlagstoneTheme.palette.text.light + " !important",
    },

    navigationIcon: {
        width: "24px",
        height: "24px",

        strokeWidth: "1.4px"
    },

    activeIcon: {
        stroke: "white",
    },
    activeHomeIcon: {
        stroke: "white"
    },
    activeProductionIcon: {
        // fill: "white",
        stroke: "white",
        // strokeWidth: "0.3px"
    },
    list: {
        height: "100%"
    },
    toolbar: {
        height: "51px",
        paddingTop: "3px",
        font: "3px",

        display: 'flex',
        alignItems: 'center'
    },
    productIcon: {
        width: "25px",
        position: "relative",
        bottom: "2px"
    },
    scheduleIcon: {
        width: "25px",
        position: "relative",
        bottom: "2px",
        left: "1px"
    }
}));

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        user: state.user,

    }
}

export default connect(mapStateToProps)(NavDrawer)